module.exports = __webpack_public_path__ + "static/media/spend-by-region.4aab572c.png";